// removed by extract-text-webpack-plugin
module.exports = {"baseColor":"#007bff"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = hvFc
// module chunks = 1